/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as MobileAuthRouteImport } from './routes/mobile-auth'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as AuthChatRouteImport } from './routes/auth/chat'
import { Route as AuthVideoCallIndexRouteImport } from './routes/auth/video/call/index'

const IndexLazyRouteImport = createFileRoute('/')()
const AuthSettingsLazyRouteImport = createFileRoute('/auth/settings')()

const MobileAuthRoute = MobileAuthRouteImport.update({
  id: '/mobile-auth',
  path: '/mobile-auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const AuthSettingsLazyRoute = AuthSettingsLazyRouteImport.update({
  id: '/auth/settings',
  path: '/auth/settings',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth/settings.lazy').then((d) => d.Route))
const AuthChatRoute = AuthChatRouteImport.update({
  id: '/auth/chat',
  path: '/auth/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVideoCallIndexRoute = AuthVideoCallIndexRouteImport.update({
  id: '/auth/video/call/',
  path: '/auth/video/call/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/error': typeof ErrorRoute
  '/mobile-auth': typeof MobileAuthRoute
  '/auth/chat': typeof AuthChatRoute
  '/auth/settings': typeof AuthSettingsLazyRoute
  '/auth/video/call': typeof AuthVideoCallIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/error': typeof ErrorRoute
  '/mobile-auth': typeof MobileAuthRoute
  '/auth/chat': typeof AuthChatRoute
  '/auth/settings': typeof AuthSettingsLazyRoute
  '/auth/video/call': typeof AuthVideoCallIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/error': typeof ErrorRoute
  '/mobile-auth': typeof MobileAuthRoute
  '/auth/chat': typeof AuthChatRoute
  '/auth/settings': typeof AuthSettingsLazyRoute
  '/auth/video/call/': typeof AuthVideoCallIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/error'
    | '/mobile-auth'
    | '/auth/chat'
    | '/auth/settings'
    | '/auth/video/call'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error'
    | '/mobile-auth'
    | '/auth/chat'
    | '/auth/settings'
    | '/auth/video/call'
  id:
    | '__root__'
    | '/'
    | '/error'
    | '/mobile-auth'
    | '/auth/chat'
    | '/auth/settings'
    | '/auth/video/call/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  ErrorRoute: typeof ErrorRoute
  MobileAuthRoute: typeof MobileAuthRoute
  AuthChatRoute: typeof AuthChatRoute
  AuthSettingsLazyRoute: typeof AuthSettingsLazyRoute
  AuthVideoCallIndexRoute: typeof AuthVideoCallIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/mobile-auth': {
      id: '/mobile-auth'
      path: '/mobile-auth'
      fullPath: '/mobile-auth'
      preLoaderRoute: typeof MobileAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/settings': {
      id: '/auth/settings'
      path: '/auth/settings'
      fullPath: '/auth/settings'
      preLoaderRoute: typeof AuthSettingsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/chat': {
      id: '/auth/chat'
      path: '/auth/chat'
      fullPath: '/auth/chat'
      preLoaderRoute: typeof AuthChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/video/call/': {
      id: '/auth/video/call/'
      path: '/auth/video/call'
      fullPath: '/auth/video/call'
      preLoaderRoute: typeof AuthVideoCallIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  ErrorRoute: ErrorRoute,
  MobileAuthRoute: MobileAuthRoute,
  AuthChatRoute: AuthChatRoute,
  AuthSettingsLazyRoute: AuthSettingsLazyRoute,
  AuthVideoCallIndexRoute: AuthVideoCallIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
